module.exports = __webpack_public_path__ + "img/slide_6.50724fd7.jpg";